import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

export default function StickyCTA() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Logic: Only show when scrolled past the hero (100svh)
      // This prevents the sticky CTA from overlapping the hero buttons
      const heroHeight = window.innerHeight;
      setIsVisible(window.scrollY > heroHeight * 0.95);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToContact = () => {
    document.getElementById('contact-section')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ y: 100 }}
          animate={{ y: 0 }}
          exit={{ y: 100 }}
          className="fixed bottom-0 left-0 right-0 z-[100] p-4 md:hidden"
        >
          <button
            onClick={scrollToContact}
            className="w-full bg-olive text-white py-4.5 uppercase tracking-[0.2em] text-[11px] font-bold shadow-[0_-10px_30px_rgba(0,0,0,0.2)]"
          >
            Schedule Private Tour
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
}